// GENERATED FILE - do not edit by hand.
// Source: data/photon/releases/*.json (contract: data/photon/release.schema.json)
// Regenerate: pnpm photon:releases (runs automatically on predev/prebuild).

import type {
  ModelFamily,
  ReleaseModel,
  SupportRow,
  Update,
} from "../release-types";
import { familyDescription } from "../editorial";

/** All declared models (id, family, release, variant), name order. */
export const RELEASE_MODELS: ReleaseModel[] = [
  {
    "id": "gemma-4-e2b",
    "name": "Gemma 4 E2B",
    "family": "Gemma",
    "release": "4",
    "variant": "E2B",
    "revision": "3e22461f65e89153144f8adb70e3b8c2cc9845a7",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "gemma-4-e4b",
    "name": "Gemma 4 E4B",
    "family": "Gemma",
    "release": "4",
    "variant": "E4B",
    "revision": "ee0ef6023621cff504d758262d4e04895a5af4a2",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "moondream-2",
    "name": "Moondream 2",
    "family": "Moondream VLM",
    "release": "2",
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "moondream-3",
    "name": "Moondream 3",
    "family": "Moondream VLM",
    "release": "3",
    "revision": "5112966d1a723413b1c9a1e8bea272b72e647b35",
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "parakeet-tdt-0-6b-v3",
    "name": "Parakeet TDT 0.6B v3",
    "family": "Parakeet",
    "release": "tdt-0.6b-v3",
    "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
    "capabilities": [
      "Transcribe"
    ],
    "modalities": "Audio → text"
  },
  {
    "id": "qwen-3-5-0-8b",
    "name": "Qwen 3.5 0.8B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "0.8B",
    "revision": "2fc06364715b967f1860aea9cf38778875588b17",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-2b",
    "name": "Qwen 3.5 2B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "2B",
    "revision": "15852e8c16360a2fea060d615a32b45270f8a8fc",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-4b",
    "name": "Qwen 3.5 4B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "4B",
    "revision": "851bf6e806efd8d0a36b00ddf55e13ccb7b8cd0a",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-9b",
    "name": "Qwen 3.5 9B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "9B",
    "revision": "c202236235762e1c871ad0ccb60c8ee5ba337b9a",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-27b",
    "name": "Qwen 3.5 27B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "27B",
    "revision": "fc05daec18b0a78c049392ed2e771dde82bdf654",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen-3-5-35b-a3b",
    "name": "Qwen 3.5 35B-A3B",
    "family": "Qwen 3",
    "release": "3.5",
    "variant": "35B-A3B",
    "revision": "59d61f3ce65a6d9863b86d2e96597125219dc754",
    "capabilities": [
      "Query",
      "Caption"
    ],
    "modalities": "Image + text → text"
  },
  {
    "id": "qwen3-asr-0-6b",
    "name": "Qwen3-ASR 0.6B",
    "family": "Qwen3-ASR",
    "release": "3",
    "variant": "0.6B",
    "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
    "capabilities": [
      "Transcribe"
    ],
    "modalities": "Audio → text"
  },
  {
    "id": "qwen3-asr-1-7b",
    "name": "Qwen3-ASR 1.7B",
    "family": "Qwen3-ASR",
    "release": "3",
    "variant": "1.7B",
    "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
    "capabilities": [
      "Transcribe"
    ],
    "modalities": "Audio → text"
  },
  {
    "id": "whisper-large-v3-turbo",
    "name": "Whisper large-v3-turbo",
    "family": "Whisper",
    "release": "large-v3-turbo",
    "revision": "deadbeefdeadbeefdeadbeefdeadbeefdeadbeef",
    "capabilities": [
      "Transcribe"
    ],
    "modalities": "Audio → text"
  }
];

/** Support matrix across all releases, status-major then model order. */
export const SUPPORT_MATRIX: SupportRow[] = [
  {
    "id": "gemma-4-e2b-a10",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e2b-a100",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e2b-b200",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e2b-h100",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e2b-l4",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e2b-rtx-3090",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e2b-rtx-pro-6000-blackwell",
    "model": "Gemma 4 E2B",
    "modelSlug": "gemma-4-e2b",
    "family": "Gemma",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-a10",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-a100",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-b200",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e4b-h100",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "gemma-4-e4b-l4",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-rtx-3090",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "gemma-4-e4b-rtx-pro-6000-blackwell",
    "model": "Gemma 4 E4B",
    "modelSlug": "gemma-4-e4b",
    "family": "Gemma",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-a10",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "A10 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-a40",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "A40",
    "target": "NVIDIA Ampere",
    "testedHardware": "A40 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-a100",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "A100 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-b200",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-gh200",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "GH200",
    "target": "NVIDIA Hopper",
    "testedHardware": "GH200 96GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-h100",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-h200",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "H200",
    "target": "NVIDIA Hopper",
    "testedHardware": "H200 SXM 141GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-jetson-agx-orin",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "Jetson AGX Orin",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson AGX Orin 64GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-jetson-orin-nano",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "Jetson Orin Nano",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin Nano 8GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-jetson-orin-nx",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "Jetson Orin NX",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin NX 16GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-l4",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L4 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-l40s",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "L40S",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L40S 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-2-rtx-30-series",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "RTX 30 series",
    "target": "NVIDIA Ampere",
    "testedHardware": "RTX 3090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-rtx-3090",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-rtx-4090",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "RTX 4090",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "RTX 4090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "1.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-2-rtx-pro-6000-blackwell",
    "model": "Moondream 2",
    "modelSlug": "moondream-2",
    "family": "Moondream VLM",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-a10",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "A10 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-a40",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "A40",
    "target": "NVIDIA Ampere",
    "testedHardware": "A40 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-a100",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "A100 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-b200",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-gh200",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "GH200",
    "target": "NVIDIA Hopper",
    "testedHardware": "GH200 96GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-h100",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-h200",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "H200",
    "target": "NVIDIA Hopper",
    "testedHardware": "H200 SXM 141GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-jetson-agx-orin",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "Jetson AGX Orin",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson AGX Orin 64GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-jetson-orin-nano",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "Jetson Orin Nano",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin Nano 8GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-09-01",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-jetson-orin-nx",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "Jetson Orin NX",
    "target": "NVIDIA Ampere",
    "testedHardware": "Jetson Orin NX 16GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-09-01",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-l4",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L4 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-l40s",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "L40S",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "L40S 48GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "moondream-3-rtx-30-series",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "RTX 30 series",
    "target": "NVIDIA Ampere",
    "testedHardware": "RTX 3090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-rtx-3090",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-rtx-4090",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "RTX 4090",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "RTX 4090 24GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-04",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "moondream-3-rtx-pro-6000-blackwell",
    "model": "Moondream 3",
    "modelSlug": "moondream-3",
    "family": "Moondream VLM",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption",
      "Detect",
      "Point",
      "Segment"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "parakeet-tdt-0-6b-v3-a10",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-a100",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-b200",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-h100",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-l4",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "parakeet-tdt-0-6b-v3-rtx-3090",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "parakeet-tdt-0-6b-v3-rtx-pro-6000-blackwell",
    "model": "Parakeet TDT 0.6B v3",
    "modelSlug": "parakeet-tdt-0-6b-v3",
    "family": "Parakeet",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-a10",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-a100",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-b200",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-0-8b-h100",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-0-8b-l4",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-rtx-3090",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-0-8b-rtx-pro-6000-blackwell",
    "model": "Qwen 3.5 0.8B",
    "modelSlug": "qwen-3-5-0-8b",
    "family": "Qwen 3",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-a10",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-a100",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-b200",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-2b-h100",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-2b-l4",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-rtx-3090",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-2b-rtx-pro-6000-blackwell",
    "model": "Qwen 3.5 2B",
    "modelSlug": "qwen-3-5-2b",
    "family": "Qwen 3",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-a10",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-a100",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-b200",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-4b-h100",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-4b-l4",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-rtx-3090",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-4b-rtx-pro-6000-blackwell",
    "model": "Qwen 3.5 4B",
    "modelSlug": "qwen-3-5-4b",
    "family": "Qwen 3",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-a10",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-a100",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-b200",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-30",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-9b-h100",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.0",
    "lastVerified": "2026-08-03",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen-3-5-9b-l4",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-rtx-3090",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen-3-5-9b-rtx-pro-6000-blackwell",
    "model": "Qwen 3.5 9B",
    "modelSlug": "qwen-3-5-9b",
    "family": "Qwen 3",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Query",
      "Caption"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen3-asr-0-6b-a10",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-a100",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-b200",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-h100",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-l4",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-0-6b-rtx-3090",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen3-asr-0-6b-rtx-pro-6000-blackwell",
    "model": "Qwen3-ASR 0.6B",
    "modelSlug": "qwen3-asr-0-6b",
    "family": "Qwen3-ASR",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen3-asr-1-7b-a10",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-a100",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-b200",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-h100",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-l4",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "qwen3-asr-1-7b-rtx-3090",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "qwen3-asr-1-7b-rtx-pro-6000-blackwell",
    "model": "Qwen3-ASR 1.7B",
    "modelSlug": "qwen3-asr-1-7b",
    "family": "Qwen3-ASR",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-a10",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "A10",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A10/A10G",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-a100",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "A100",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA A100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-b200",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "B200",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA B200",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "whisper-large-v3-turbo-h100",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "H100",
    "target": "NVIDIA Hopper",
    "testedHardware": "H100 SXM 80GB",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.1",
    "lastVerified": "2026-08-31",
    "supported": true,
    "validated": true,
    "benchmarked": true
  },
  {
    "id": "whisper-large-v3-turbo-l4",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "L4",
    "target": "NVIDIA Ada Lovelace",
    "testedHardware": "NVIDIA L4",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-rtx-3090",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "RTX 3090",
    "target": "NVIDIA Ampere",
    "testedHardware": "NVIDIA RTX 3090",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  },
  {
    "id": "whisper-large-v3-turbo-rtx-pro-6000-blackwell",
    "model": "Whisper large-v3-turbo",
    "modelSlug": "whisper-large-v3-turbo",
    "family": "Whisper",
    "chip": "RTX PRO 6000 Blackwell",
    "target": "NVIDIA Blackwell",
    "testedHardware": "NVIDIA RTX PRO 6000 Blackwell",
    "precision": [
      "BF16"
    ],
    "capabilities": [
      "Transcribe"
    ],
    "status": "production",
    "since": "2.2",
    "lastVerified": "2026-09-09",
    "supported": true,
    "validated": true,
    "benchmarked": false
  }
];

/** Production model families for the /photon cards. */
export const MODEL_FAMILIES: ModelFamily[] = [
  {
    id: "moondream-vlm",
    name: "Moondream VLM",
    versions: [],
    releases: [
  {
    "name": "2",
    "status": "production"
  },
  {
    "name": "3",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Moondream VLM"),
    capabilities: [
  "Query",
  "Caption",
  "Detect",
  "Point",
  "Segment"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "A10 24GB",
  "A40 48GB",
  "A100 80GB",
  "NVIDIA B200",
  "GH200 96GB",
  "H100 SXM 80GB",
  "H200 SXM 141GB",
  "Jetson AGX Orin 64GB",
  "Jetson Orin Nano 8GB",
  "Jetson Orin NX 16GB",
  "L4 24GB",
  "L40S 48GB",
  "RTX 3090 24GB",
  "NVIDIA RTX 3090",
  "RTX 4090 24GB",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 1.0",
  },
  {
    id: "qwen-3",
    name: "Qwen 3",
    versions: [
  "0.8B",
  "2B",
  "4B",
  "9B"
],
    releases: [
  {
    "name": "3.5",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Qwen 3"),
    capabilities: [
  "Query",
  "Caption"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.0",
  },
  {
    id: "gemma",
    name: "Gemma",
    versions: [
  "E2B",
  "E4B"
],
    releases: [
  {
    "name": "4",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Gemma"),
    capabilities: [
  "Query",
  "Caption"
],
    modalities: "Image + text → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.0",
  },
  {
    id: "whisper",
    name: "Whisper",
    versions: [],
    releases: [
  {
    "name": "large-v3-turbo",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Whisper"),
    capabilities: [
  "Transcribe"
],
    modalities: "Audio → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.1",
  },
  {
    id: "qwen3-asr",
    name: "Qwen3-ASR",
    versions: [
  "0.6B",
  "1.7B"
],
    releases: [
  {
    "name": "3",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Qwen3-ASR"),
    capabilities: [
  "Transcribe"
],
    modalities: "Audio → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.1",
  },
  {
    id: "parakeet",
    name: "Parakeet",
    versions: [],
    releases: [
  {
    "name": "tdt-0.6b-v3",
    "status": "production"
  }
],
    status: "production",
    description: familyDescription("Parakeet"),
    capabilities: [
  "Transcribe"
],
    modalities: "Audio → text",
    verifiedHardware: [
  "NVIDIA A10/A10G",
  "NVIDIA A100 SXM 80GB",
  "NVIDIA B200",
  "H100 SXM 80GB",
  "NVIDIA L4",
  "NVIDIA RTX 3090",
  "NVIDIA RTX PRO 6000 Blackwell"
],
    introducedIn: "Photon 2.1",
  },
];

/** Product updates across all releases, newest first. */
export const UPDATES: Update[] = [
  {
    "id": "photon-2-2-expanded-gpu-support",
    "date": "2026-09-09",
    "version": "2.2",
    "type": "hardware",
    "title": "Fast inference across four NVIDIA GPU generations",
    "impact": "Run the Photon model catalog across Ampere, Ada, Hopper, and Blackwell GPUs.",
    "models": [],
    "hardware": [
      "NVIDIA A10/A10G",
      "NVIDIA A100",
      "NVIDIA RTX 3090",
      "NVIDIA L4",
      "NVIDIA H100",
      "NVIDIA B200",
      "NVIDIA RTX PRO 6000 Blackwell"
    ],
    "statusChange": "Expanded production support",
    "knownLimitations": [
      "New Photon 2.2 vision and language performance numbers are not available yet."
    ]
  },
  {
    "id": "photon-2-2-faster-moondream-qwen",
    "date": "2026-09-09",
    "version": "2.2",
    "type": "performance",
    "title": "Faster local Moondream and Qwen inference",
    "impact": "Local Moondream and Qwen workloads now return responses faster and process more requests.",
    "models": [
      "Moondream",
      "Qwen"
    ],
    "hardware": [
      "NVIDIA A10/A10G",
      "NVIDIA A100",
      "NVIDIA RTX 3090",
      "NVIDIA L4",
      "NVIDIA H100",
      "NVIDIA B200",
      "NVIDIA RTX PRO 6000 Blackwell"
    ],
    "benchmarkImpact": "Response latency and throughput improved across supported GPUs.",
    "knownLimitations": [
      "Updated vision and language benchmark numbers are not available yet."
    ]
  },
  {
    "id": "photon-2-2-whisper-l4-rtx-3090",
    "date": "2026-09-09",
    "version": "2.2",
    "type": "capability",
    "title": "Accelerated Whisper transcription on L4 and RTX 3090",
    "impact": "Run accelerated local Whisper transcription on NVIDIA L4 and RTX 3090 GPUs.",
    "models": [
      "Whisper"
    ],
    "hardware": [
      "NVIDIA L4",
      "NVIDIA RTX 3090"
    ],
    "statusChange": "Available in Photon 2.2",
    "knownLimitations": [
      "Photon 2.2 Whisper performance numbers for L4 and RTX 3090 are not available yet."
    ]
  },
  {
    "id": "photon-2-2-faster-asr",
    "date": "2026-09-09",
    "version": "2.2",
    "type": "performance",
    "title": "Lower ASR latency and host overhead",
    "impact": "Qwen3-ASR and Parakeet transcription now runs with lower latency and less host overhead, especially at concurrency 1.",
    "models": [
      "Qwen3-ASR 0.6B",
      "Qwen3-ASR 1.7B",
      "Parakeet TDT 0.6B v3"
    ],
    "hardware": [
      "NVIDIA L4",
      "NVIDIA A10/A10G",
      "NVIDIA A100 SXM 80GB"
    ],
    "benchmarkImpact": "Photon beat the relevant reference engine in 35 of 36 matched speech throughput configurations, tied one, and reached up to 4.83x throughput."
  },
  {
    "id": "photon-2-0-1-large-image-cpu-decode-fix",
    "date": "2026-08-04",
    "version": "2.0.1",
    "type": "fix",
    "title": "Large-image CPU decode fix",
    "impact": "Requests with images above 4 MP no longer fail on the CPU decode path before reaching the megakernel.",
    "models": [],
    "hardware": [],
    "knownLimitations": [
      "Images above 16 MP are still rejected at the API boundary."
    ]
  },
  {
    "id": "photon-2-0-qwen-3-5-and-gemma-4-support",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "model",
    "title": "Qwen 3.5 and Gemma 4 support",
    "impact": "Photon 2.0 adds production support for Qwen 3.5 (0.8B-9B) and Gemma 4 E2B/E4B.",
    "models": [
      "Qwen 3.5 0.8B",
      "Qwen 3.5 2B",
      "Qwen 3.5 4B",
      "Qwen 3.5 9B",
      "Gemma 4 E2B",
      "Gemma 4 E4B"
    ],
    "hardware": [
      "H100"
    ],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally",
      "supportRows": [
        "qwen-3-5-0-8b-h100",
        "qwen-3-5-4b-h100",
        "gemma-4-e2b-h100",
        "gemma-4-e4b-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-h100-80gb-support",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "hardware",
    "title": "H100 80GB support",
    "impact": "Photon 2.0 is tested on H100 SXM 80GB across all launch models.",
    "models": [],
    "hardware": [
      "H100"
    ],
    "benchmarkImpact": "Photon was ahead in all 52 matched throughput comparisons: 28 against vLLM and 24 against SGLang, from 1.01x to 2.33x on ChartQA at concurrency 1-8.",
    "links": {
      "supportRows": [
        "moondream-3-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-lower-cold-start-time",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "performance",
    "title": "Lower cold-start time",
    "impact": "Matched cold-start tests reached first response faster on Photon than vLLM and SGLang for the launch models.",
    "models": [],
    "hardware": [
      "H100"
    ],
    "benchmarkImpact": "Photon had up to 66% lower total cold-start time than vLLM across seven models and up to 55% lower time than SGLang across six supported models."
  },
  {
    "id": "photon-2-0-moondream-3-segmentation",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "capability",
    "title": "Moondream 3 segmentation",
    "impact": "Moondream 3 on Photon serves segmentation masks alongside query, caption, detect, and point.",
    "models": [
      "Moondream 3"
    ],
    "hardware": [
      "H100"
    ],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally",
      "supportRows": [
        "moondream-3-h100"
      ]
    }
  },
  {
    "id": "photon-2-0-compiled-megakernel-execution",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "runtime",
    "title": "Compiled megakernel execution",
    "impact": "Request handling, tokenization, and image decode stay on the CPU. Model execution runs inside one compiler-generated GPU program.",
    "models": [],
    "hardware": [],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally"
    }
  },
  {
    "id": "photon-2-0-md-photon-requires-moondream-sdk-0-11",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "compatibility",
    "title": "md.photon() requires moondream SDK 0.11+",
    "impact": "md.photon() needs moondream 0.11 or later. Earlier SDKs stay on Moondream-only local inference.",
    "models": [],
    "hardware": [],
    "links": {
      "docs": "https://docs.moondream.ai/running-locally"
    }
  },
  {
    "id": "photon-2-0-photon-1-x-edge-support-ended",
    "date": "2026-08-03",
    "version": "2.0",
    "type": "deprecation",
    "title": "Photon 1.x edge support ended",
    "impact": "Moondream 2 on A10 and Jetson AGX Orin is no longer supported for new deployments.",
    "models": [
      "Moondream 2"
    ],
    "hardware": [
      "A10",
      "Jetson AGX Orin"
    ],
    "knownLimitations": [
      "Photon 1.x configurations receive critical fixes only."
    ]
  }
];
